export default class MikomiTeam
{
    constructor(teamName)
    {
        this.Name = teamName;
        this.Data = [];
    }
}